// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"c1a78f550d330a03","4823":"451a41cd73a8568d","4989":"4f9c6a0808eba73f"}[chunkId] + ".css";
};